import React, { useEffect, useState, useRef } from "react";

import { Form, Input, Button, Alert, DatePicker, Result, Table, Select } from "antd";
import moment from "moment";
import { formatPrice } from "../../../lib/helpers";

const Widget = (props) => {
    const expandedRowRender = (record, index, indent, expanded) => {
        return <Table
            columns={[
                {
                    dataIndex: "name",
                    render: (value, record) => {
                        return <React.Fragment>
                            {record.name} = <span className="text-danger">{formatPrice(record.value)} VND</span>
                        </React.Fragment>
                    }
                }
            ]}
            dataSource={record.data}
            pagination={false}
            showHeader={false}
        />;
    };

    return <React.Fragment>
        <div className="pl-4">
            <Table
                dataSource={props.data.map((item, i) => {
                    return {
                        key: i,
                        name: item._id.bac_sy,
                        value: item.tong,
                        so_luong: item.so_luong,
                        data: [
                            {
                                key: `${i}1`,
                                name: "Dịch vụ",
                                value: item.dich_vu
                            },
                            {
                                key: `${i}2`,
                                name: "Thuốc",
                                value: item.thuoc
                            },
                            {
                                key: `${i}3`,
                                name: "Kính",
                                value: item.kinh
                            },
                            {
                                name: "Gói mổ",
                                value: props.data.reduce((a, b) => a + b.goi_mo, 0)
                            }
                        ]
                    }
                })}
                columns={[
                    {
                        dataIndex: "name",
                        render: (value, record) => {
                            return <React.Fragment>
                                {record.name} = {record.so_luong} = <span className="text-danger">{formatPrice(record.value)} VND</span>
                            </React.Fragment>
                        }
                    }
                ]}
                showHeader={false}
                pagination={false}
                bordered={false}
                size={"small"}
                expandable={{ expandedRowRender, defaultExpandAllRows: false, showExpandColumn: false, defaultExpandedRowKeys: [0,1,2,3,4,5]}}
            />
        </div>
    </React.Fragment>;
};

export default Widget;
